'use strict';
/** @type {!Array} */
var user_movement_array = ["mouseover", "keydown", "touchmove", "touchstart", "wheel"];
/** @type {!Array<PerformanceEntry>} */
var perfEntries = performance.getEntriesByType("navigation");
var perfEntries_fallback = performance.timing;
/**
 * @return {undefined}
 */
function delay_js_controller() {
	alt_observer.disconnect();
	block_event_load_array();
	user_movement_array.forEach(function(type) {
		window.removeEventListener(type, delay_js_controller, {
			passive: true
		});
	});
	load_all_js_array();
}
/**
 * @param {!Array} params
 * @param {!Function} name
 * @param {number} index
 * @return {undefined}
 */
function seq(params, name, index) {
	if (void 0 === index) {
		/** @type {number} */
		index = 0;
	}
	params[index](function() {
		if (++index === params.length) {
			name();
		} else {
			seq(params, name, index);
		}
	});
}
/**
 * @return {undefined}
 */
function load_all_event_array() {
	if (  perfEntries["loadEventEnd"] > 0  || perfEntries_fallback["loadEventEnd"] > 0 ) {
          console.log("😀");
		/** @type {(Event|null)} */
		var ev = document.createEvent("Event");
		ev.initEvent("DOMContentLoaded", true, true);
		window.dispatchEvent(ev);
		document.dispatchEvent(ev);
		/** @type {(Event|null)} */
		var newEvent = document.createEvent("Event");
		newEvent.initEvent("readystatechange", true, true);
		window.dispatchEvent(newEvent);
		document.dispatchEvent(newEvent);
		/** @type {(Event|null)} */
		var event = document.createEvent("Event");
		event.initEvent("load", true, true);
		window.dispatchEvent(event);
		document.dispatchEvent(event);
		/** @type {(Event|null)} */
		var e = document.createEvent("Event");
		e.initEvent("show", true, true);
		window.dispatchEvent(e);
		document.dispatchEvent(e);
		var evt = window.document.createEvent("UIEvents");
		evt.initUIEvent("resize", true, true, window, 0);
		window.dispatchEvent(evt);
		document.dispatchEvent(evt);
        window.dispatchEvent(new Event("FireInline_Delayshopifyscript"));
	}
}
/**
 * @param {!Object} result
 * @param {!Function} resolve
 * @return {undefined}
 */
function script_collection_array(result, resolve) {
	/** @type {!Element} */
	var data = document.createElement("script");
	/** @type {string} */
	data.type = "text/javascript";
	if (result.src) {
		/** @type {!Function} */
		data.onload = resolve;
		/** @type {!Function} */
		data.onerror = resolve;
		data.src = result.src;
		data.id = result.id;
		/** @type {boolean} */
		data.async = false;
		Object.assign(data.dataset, result.dataset);
	} else {
		data.textContent = result.innerText;
		data.id = result.id;
		/** @type {boolean} */
		data.async = false;
		Object.assign(data.dataset, result.dataset);
	}
	result.parentNode.removeChild(result);
	document.body.appendChild(data);
	if (!result.src) {
		resolve();
	}
}
/**
 * @return {undefined}
 */
function load_all_js_array() {
	/** @type {!NodeList<Element>} */
	var nextBlock = document.querySelectorAll("script");
	/** @type {!Array} */
	var params = [];
	[].forEach.call(nextBlock, function(t) {
		if ("text/delayshopifyscript" == t.getAttribute("type")) {
			params.push(function(results) {
				script_collection_array(t, results);
			});
		}
	});
	seq(params, load_all_event_array);
}
/**
 * @return {undefined}
 */
function block_event_load_array() {
    console.log("😡");
	if (  (perfEntries["loadEventEnd"] > 0  || perfEntries_fallback["loadEventEnd"] > 0) && typeof document.removeEventListeners !== "undefined"  ) {
		document.removeEventListeners("DOMContentLoaded");
		document.removeEventListeners("load");
	}
}
user_movement_array.forEach(function(t) {
	window.addEventListener(t, delay_js_controller, {
		passive: true
	});
});